import React, { Component } from 'react';
import { connect } from 'react-redux';
import { forgotPassword } from '../../actions/sessions';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import MemberService from '../../services/memberService';
import CONSTANTS from '../../constants'

class ForgotPassword extends Component {

    constructor(props) {
        MemberService.logout();
        super(props);
        const bname = props.match.params.bname;
        this.state = {
            email: '',
            bname: bname
        };
    }


    renderField(field) {
        let hasError = field.meta.touched && field.meta.error;
        return (
            <div className="form-group">
                <div className="input-group">
                    <span className="input-group-addon is-invalid"><i className={field.icon}></i></span>
                    <input {...field.input}  className={`form-control ${hasError ? 'is-invalid' : ''}`} type={field.type}
                           placeholder={field.placeholder} value={field.value} />
                </div>
                <div className="invalid-feedback">
                    { hasError ? field.meta.error : ''}
                </div>
            </div>
        )
    }

    onSubmit(values) {
        this.props.forgotPassword(this.state.bname, values.email, this.props.history);
    }

    render () {
        const { handleSubmit } = this.props;
        return (
            <div className="flex-center">
                <div className="content-card col-lg-6 col-xs-12">
                    <h1>{CONSTANTS.APP_TITLE}</h1>
                    <p className="text-muted">Forgot your password?</p>
                    <form className="members-area-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                        <Field
                            name="email"
                            type="email"
                            placeholder="Email"
                            className="form-control"
                            icon="far fa-user"
                            value={this.state.email}
                            component={this.renderField}
                        />
                        <button type="submit" className="btn btn-lg btn-primary full-width">Get password reset instructions</button>
                    </form>
                    <div className="text-center small mt-10">
                        <span className="text-muted">Already have a login? &nbsp;</span>
                        <Link to={`/${this.state.bname}/login`}>Login here</Link>
                    </div>
                </div>
            </div>
        );
    }
}

function validate(values) {
    let errors = {};

    if(!values.email)
        errors.email = 'Please enter an email';
    return errors;
}

export default reduxForm({validate: validate, form: 'forgotPasswordForm'})(connect(null, { forgotPassword })(ForgotPassword));
